import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nProvider } from './lib/i18n/I18nProvider';
import { App } from './app/App';
import './styles/app.css';

/**
 * Vite's `BASE_URL` is only the STATIC-ASSET mount (`/_dashboard/` in production). The user-facing
 * routes remain `/admin`, `/brokerage`, `/developer` and `/portal`, so feeding `BASE_URL` to React
 * Router makes every production URL fall outside its basename and leaves `#root` empty.
 */
const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <I18nProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </I18nProvider>
  </StrictMode>,
);
